import request from '@/utils/request';

//登录
export function VolunteerLogin(data) {
  return request({
    url: '/wx/weiXinInter/toLogin.do',
    method: 'post',
		data
  })
}
//查询志愿者信息
export function GetVolunteerInfo(data) {
  return request({
    url: '/wx/postulant/getUserInfo.do',
    method: 'post',
		data
  })
}

/* 修改志愿者信息 */
export function modifyVolInfo(data){
	return request({
		url: '/wx/postulant/updateUserInfo.do',
		method: 'post',
		headers: {
		  'Content-Type': 'multipart/form-data'
		},
		data
	})
}

//统计我今年的签到时长
export function getMyHours(data) {
  return request({
    url: '/wx/attendance/getVolunteerAttendance.do',
    method: 'post',
		data
  })
}

//统计我的签到时长等
export function getMyService(data) {
  return request({
    url: '/wx/attendance/getVolunteerAttendanceTj.do',
    method: 'post',
		data
  })
}

//查询服装信息
export function selectVolClothes(data) {
  return request({
    url: '/wx/infoClothing/getInfoClothing.do',
    method: 'post',
		data
  })
}

//查询服装型号
export function selectClothingType(data) {
  return request({
    url: '/wx/infoClothing/getClothingType.do',
    method: 'post',
		data
  })
}
//服装申请
export function clothApplication(data) {
  return request({
    url: '/wx/infoClothing/addClothingApplication.do',
    method: 'post',
		data
  })
}

//获取未查看通知
export function findNoreadNews(data) {
  return request({
    url: '/wx/volSys/toSee.do',
    method: 'post',
		data
  })
}

/* 获取OpenId */
export function getOpenId(data){
	return request({
		url: '/wx/weiXinInter/getOpenid.do',
		method: 'get',
		params:data
	})
}

/* 获取手机验证码 */
export function getVerification(data){
	return request({
		url: '/wx/weiXinInter/toVerification.do',
		method: 'post',
		headers: {'Content-Type':'application/json'},
		data
	})
}

/* 签到//签退 */
export function volAttendance(data){
	return request({
		url: '/wx/attendance/saveAttendance.do',
		method: 'post',
		data
	})
}
/* 可签到检查 */
export function attendanceCheck(data){
	return request({
		url: '/wx/attendance/getAttendanceType.do',
		method: 'post',
		data
	})
}



// WEBPACK FOOTER //
// ./src/api/login.js